// Landing-page pricing, matched to the Assessment Shop: every assessment and every report is its own item with its
// own price, bought in any quantity. No prices are printed here — the shop is the single source of truth for them.
import { INSTRUMENT_COUNT } from "../../constants/platformStats.js";
import { SectionHead, T } from "./glass.jsx";

const N="#0d1b36", MU="#5b6b86", GOLD="#b9822e", GREEN="#059669", SL="#475569";
const STEPS = [
  { n:"1", t:"Pick what you need", d:"Each assessment and each report is its own item, in any quantity. Nothing is bundled." },
  { n:"2", t:"Pay securely online", d:"Checkout through Razorpay. An invoice is issued for every order, with GST handled for you." },
  { n:"3", t:"Use it when you need it", d:"Purchased units never expire and are used up before any credits, one per assessment or report." },
];

export default function ShopPricing({ onEnter, waUrl, email }) {
  return (
    <section id="pricing" aria-label="AXIS360 Assessment Platform Pricing" className="sec">
      <div className="wrap" style={{ maxWidth:1100 }}>
        <SectionHead eyebrow="Pricing" title="Pay for what you use." accent="No per-seat licensing."
          lead="Every assessment and every report has its own price in the Assessment Shop. Buy exactly the tests and reports you need, in the quantities you need, with no subscription."/>

        {/* The headline number, with its footnote */}
        <div style={{ textAlign:"center", marginBottom:28 }}>
          <div className="navy" style={{ display:"inline-flex", alignItems:"baseline", gap:14, flexWrap:"wrap", justifyContent:"center", padding:"16px 30px" }}>
            <span style={{ fontSize:11, fontWeight:700, color:"rgba(255,255,255,.6)", letterSpacing:1.4, textTransform:"uppercase" }}>Assessments from</span>
            <span className="serif" style={{ fontSize:46, fontWeight:700, color:"#e0b36b", lineHeight:1 }}>₹500*</span>
            <span style={{ fontSize:12.5, color:"rgba(255,255,255,.6)" }}>per assessment</span>
          </div>
          <div style={{ fontSize:11, color:T.mute, marginTop:12, lineHeight:1.7, maxWidth:620, marginLeft:"auto", marginRight:"auto" }}>
            * Starting price per assessment, excluding GST. Reports are priced separately. Buying in volume? <a href={waUrl} target="_blank" rel="noopener noreferrer" style={{ color:GOLD, fontWeight:700 }}>Contact us</a> for a quote.
          </div>
        </div>

        {/* How buying works */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))", gap:14, marginBottom:28 }}>
          {STEPS.map(s => (
            <div key={s.n} className="glass" style={{ padding:"18px 20px", display:"flex", gap:14 }}>
              <div style={{ width:30, height:30, borderRadius:9, background:N, color:GOLD, fontWeight:800, fontSize:13, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>{s.n}</div>
              <div>
                <div style={{ fontSize:13, fontWeight:700, color:N, marginBottom:4 }}>{s.t}</div>
                <div style={{ fontSize:11.5, color:SL, lineHeight:1.6 }}>{s.d}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Two other ways in */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))", gap:14 }}>
          <div className="glass" style={{ padding:"22px 24px" }}>
            <div className="serif" style={{ fontSize:19, fontWeight:700, color:N, marginBottom:6 }}>Try it first</div>
            <p style={{ fontSize:12, color:SL, lineHeight:1.7, margin:"0 0 14px" }}>
              Create an account with no card required and try the platform on a few candidates before you buy anything.
            </p>
            <button className="b-navy" onClick={onEnter} style={{ padding:"11px 22px", fontSize:12.5 }}>Start free →</button>
          </div>
          <div className="glass" style={{ padding:"22px 24px", borderTop:`3px solid ${GOLD}` }}>
            <div className="serif" style={{ fontSize:19, fontWeight:700, color:N, marginBottom:6 }}>Enterprise</div>
            <div style={{ display:"flex", flexDirection:"column", gap:5, marginBottom:14 }}>
              {["Unlimited assessments and reports", `All ${INSTRUMENT_COUNT} instruments`, "White-label option", "Dedicated success manager"].map(f => (
                <div key={f} style={{ display:"flex", gap:8, fontSize:12, color:"#374151" }}><span style={{ color:GREEN, fontWeight:700 }}>✓</span>{f}</div>
              ))}
            </div>
            <a className="b-gold" href={waUrl} target="_blank" rel="noopener noreferrer" style={{ display:"inline-block", padding:"11px 22px", fontSize:12.5, textDecoration:"none" }}>Talk to us →</a>
            <a href={"mailto:" + email} style={{ marginLeft:14, fontSize:11.5, color:MU }}>{email}</a>
          </div>
        </div>
      </div>
    </section>
  );
}
